import { render, staticRenderFns } from "./productImageSummary.vue?vue&type=template&id=3401951e&scoped=true&"
import script from "./productImageSummary.vue?vue&type=script&lang=js&"
export * from "./productImageSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3401951e",
  null
  
)

export default component.exports